module.exports = __webpack_public_path__ + "static/media/peopleGroup1.43a3f4d6.jpg";